import { Artist } from '@definitions/artists.types';
import { Gallery } from '@definitions/galleries.types';
import { getFullArtistName } from '@utils/helpers';

import { iAlphabetAccumulator, iLetter } from './letter.types';

const isGallery = (entity: Artist | Gallery): entity is Gallery => 'name' in entity;

const SPECIAL_CHARACTER_OR_NUMBER_SYMBOL = '#';

export const getAlphabetDivision = (items: (Artist | Gallery)[]): iLetter[] => {
  if (items.length === 0) return [];
  return Object.values(
    items.reduce((acc: iAlphabetAccumulator, item: Gallery | Artist) => {
      const nameForInitial = isGallery(item) ? item.name : item.lastName;
      const name = isGallery(item) ? item.name : getFullArtistName(item);
      const firstCharacter = nameForInitial[0].toLocaleUpperCase();
      const formattedItem = { slug: item.slug, name };
      const isSpecialCharacterOrNumber = !!firstCharacter.match(/[^A-Za-z]/g);
      const initial = isSpecialCharacterOrNumber ? SPECIAL_CHARACTER_OR_NUMBER_SYMBOL : firstCharacter;

      if (!acc[initial]) {
        acc[initial] = {
          initial: initial,
          data: [formattedItem],
        };
      } else {
        acc[initial].data.push(formattedItem);
      }

      return acc;
    }, {})
  );
};
